<app-page-heading [key]="'local-loads.reorder.title'"
                  [disableMarginBottom]="true" [carriers]="carriers" [(selectedCarrier)]="selectedCarrier" (selectedCarrierChange)="carrierChanged()">
</app-page-heading>


<div class="reorder-loads-container">
    <app-vehicle-loads-list *ngIf="selectedCarrier" [selectedCarrierId]="selectedCarrier.id" [canAssignVehicle]="canAssignVehicle" class="vehicle-loads-list"></app-vehicle-loads-list>
    <app-search-loads-list *ngIf="selectedCarrier && canAssignVehicle" [selectedCarrierId]="selectedCarrier.id" class="search-loads-list"></app-search-loads-list>
</div>
